import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { GET_COMPANY_INTEGRATION, SET_COMPANY_INTEGRATION } from "../../services/companies";
import InputField, { InputFieldTypes } from "../input_field";
import { Avatar, Box, Button, Group, Stack, Text, Title } from "@mantine/core";

export default function Intercom() {
    const [data, setData] = useState<any>(null);
    const [loadingSave, setLoadingSave] = useState<boolean>(false);
    const [updated, setUpdated] = useState<boolean>(false);

    const handleChange = dt => setData(u => ({ ...u, ...dt }))

    const loadData = () => {
        GET_COMPANY_INTEGRATION("intercom")
            .then((res) => {
                setData(res)
                setTimeout(() => { setUpdated(false) }, 800);
            })
            .catch(err => {
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    const handleSave = () => {
        setLoadingSave(true)
        SET_COMPANY_INTEGRATION("intercom", { ...data })
            .then((res) => {
                setLoadingSave(false)
                setUpdated(false);
                notifications.show({ message: "Connected on intercom to manage support", color: 'green' })
            })
            .catch(err => {
                setLoadingSave(false)
                notifications.show({ title: "Ops.", message: err.message, color: 'red' })
            })
    }

    React.useEffect(() => { loadData() }, [])
    React.useEffect(() => { setUpdated(true) }, [data])

    return <Stack>
        <Group>
            <Avatar size={40} src="/assets/intercom.webp" />
            <Title c="gray.0" order={5}>Intercom</Title>
        </Group>
        <Group align="flex-end">
            <Box style={{ flex: 1 }}>
                <InputField
                    name="app_id"
                    value={data?.app_id}
                    fieldType={InputFieldTypes.PASSWORD}
                    onChange={handleChange}
                    title="APP ID"
                    placeholder="Paste your APP ID"
                />
            </Box>
            <Box style={{ flex: 1 }}>
                <InputField
                    name="key"
                    value={data?.key}
                    fieldType={InputFieldTypes.PASSWORD}
                    onChange={handleChange}
                    title="Secret Key"
                    placeholder="Paste your SECRET KEY"
                />
            </Box>
            <Button
                disabled={
                    ((data?.key ?? "").length < 10) || ((data?.app_id ?? "").length < 3) || !updated
                }
                size="md"
                onClick={handleSave}
                loading={loadingSave}
                color="green"
            >Connect</Button>
        </Group>
    </Stack>
}
